module.exports = require('./dist/base64url').default;
module.exports.default = module.exports;



//////////////////
// WEBPACK FOOTER
// ./~/uport-base64url/index.js
// module id = 900
// module chunks = 0